const valueProps = [
  {
    label: 'Speed',
    title: 'Automated in Seconds',
    description: 'The itaobuy spreadsheet replaces slow manual agent handling with a lightning-fast automated sourcing workflow. Products are matched and processed in record time.',
    image: 'https://readdy.ai/api/search-image?query=Time%20lapse%20style%20photography%20of%20packages%20moving%20swiftly%20on%20modern%20conveyor%20system%20in%20bright%20white%20warehouse%20with%20natural%20skylight%20motion%20blur%20effect%20dynamic%20industrial%20scene&width=800&height=1067&seq=valuev2-speed-p01&orientation=portrait',
    icon: 'ri-flashlight-line',
  },
  {
    label: 'Cost',
    title: 'Lower Service Fees',
    description: 'Cut out expensive middlemen. The itaobuy spreadsheet system connects you directly with verified suppliers, dramatically reducing commission costs on every order.',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20photography%20of%20stacked%20golden%20coins%20with%20dramatic%20side%20lighting%20on%20dark%20matte%20surface%20creating%20long%20shadows%20wealth%20and%20savings%20concept%20minimal%20elegant%20composition&width=800&height=1067&seq=valuev2-cost-p02&orientation=portrait',
    icon: 'ri-money-dollar-circle-line',
    highlight: true,
  },
  {
    label: 'Transparency',
    title: 'Full Tracking Visibility',
    description: 'Every step of your order is tracked in the spreadsheet. From supplier confirmation to warehouse arrival and international shipping, nothing is hidden from you.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20glass%20display%20case%20with%20fashion%20accessories%20inside%20bright%20natural%20lighting%20through%20large%20window%20transparent%20visibility%20concept%20modern%20retail%20aesthetic%20minimal%20white%20setting&width=800&height=1067&seq=valuev2-transparency-p03&orientation=portrait',
    icon: 'ri-eye-line',
  },
];

const comparisonRows = [
  { feature: 'Speed', itaobuy: 'Fast automated process', traditional: 'Slow manual handling' },
  { feature: 'Cost', itaobuy: 'Lower service fees', traditional: 'Higher commissions' },
  { feature: 'Transparency', itaobuy: 'Full spreadsheet tracking', traditional: 'Limited visibility' },
  { feature: 'Ease of Use', itaobuy: 'Beginner-friendly', traditional: 'Complex for new users' },
  { feature: 'Scalability', itaobuy: 'Bulk order friendly', traditional: 'Limited scaling' },
];

export default function ValueProps() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12 md:mb-16">
          <div className="flex-1">
            <h2 className="text-foreground-400 text-sm font-semibold uppercase tracking-wider mb-2">
              Why Itaobuy Sheet Wins
            </h2>
            <p className="font-heading text-3xl md:text-4xl font-bold italic text-foreground-900">
              Faster, Cheaper, Safer
            </p>
          </div>
          <div className="lg:w-[55%]">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              The <strong>itaobuy spreadsheet</strong> system replaces traditional buying agents with a structured, fast, and transparent workflow designed for modern global sourcing needs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-16">
          {valueProps.map((prop) => (
            <div
              key={prop.label}
              className={`group rounded-2xl overflow-hidden ${
                prop.highlight
                  ? 'bg-foreground-950'
                  : 'bg-background-100'
              } transition-all duration-300 hover:scale-[1.02]`}
            >
              <div className="h-[240px] overflow-hidden">
                <img
                  src={prop.image}
                  alt={`${prop.label} - itaobuy spreadsheet advantage`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-3 ${
                  prop.highlight
                    ? 'bg-primary-500/20 text-primary-300'
                    : 'bg-accent-100 text-accent-700'
                }`}>
                  {prop.label}
                </span>
                <h3 className={`text-lg md:text-xl font-bold mb-2 ${
                  prop.highlight ? 'text-background-50' : 'text-foreground-900'
                }`}>
                  {prop.title}
                </h3>
                <p className={`text-sm leading-relaxed ${
                  prop.highlight ? 'text-foreground-400' : 'text-foreground-600'
                }`}>
                  {prop.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 overflow-x-auto">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
            Itaobuy Spreadsheet vs Traditional Buying Agents
          </h3>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-300">
                <th className="text-left py-3 pr-4 text-foreground-500 font-medium">Feature</th>
                <th className="text-left py-3 pr-4 text-primary-600 font-semibold">Itaobuy Spreadsheet</th>
                <th className="text-left py-3 text-foreground-400 font-medium">Traditional Agent</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row) => (
                <tr key={row.feature} className="border-b border-background-200/60">
                  <td className="py-3.5 pr-4 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="py-3.5 pr-4 text-foreground-800 whitespace-nowrap">{row.itaobuy}</td>
                  <td className="py-3.5 text-foreground-500 whitespace-nowrap">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}